import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

@HateoasResource('shares', { routeName: 'frontdoorResourceRoute' })
export class Share extends Resource {
    frontends: any;
    agents: string[];
    id: string;
    name: string;
    access: string;
    envId: string;
    authProviderId: string;
    target: string;
    namespaceId: string;
    publicName: string
    frontendEndpoint: string;
    shareToken: string;
    frontendSelection: string;
    backendProxyEndpoint: string;
    zId: string;
    token: string;
    envZId: string;
    selected=  false;
    frontendId: string;
    createdAt: string
    type: string;
    clientPublicKey: string;
    allowedSubjects: string[];
    allowedCommonNamePrefixes: string[];
    organizationalUnit: string;
    ingressPort: string;
    clientCertificateId: string;
    insecure: boolean;
    namespaceToken: string;
    useIntermediateCertificate: boolean;

}


